export default __webpack_public_path__ + "static/media/isagen.2b913a5a.png";